import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import MuiCard from '@mui/material/Card'
import AppTheme from '../shared-theme/AppTheme';
import CssBaseline from '@mui/material/CssBaseline';
import { styled } from '@mui/material/styles';

interface ConnectingProgressProps {
  open: boolean;
  service: string;
}


const Card = styled(MuiCard)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'center',
  width: '100%',
  padding: theme.spacing(4),
  gap: theme.spacing(2),
  margin: 'auto',
  [theme.breakpoints.up('sm')]: {
    maxWidth: '450px',
  },
  background: theme.palette.background.paper,
  boxShadow: theme.shadows[1],
  ...theme.applyStyles('dark', {
    background: 'hsla(220, 30%, 3%, 1)',
    boxShadow:
      'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
  }),
}));

export default function ConnectingProgress({open, service}: ConnectingProgressProps) {
  return (
    <AppTheme>
      <CssBaseline enableColorScheme />
      <Backdrop
        sx={(theme) => ({ color: theme.palette.text.primary, zIndex: theme.zIndex.drawer + 1 })}
        open={open}
      >
        <Card variant="outlined">
          <Stack direction="column" sx={{ justifyContent: "center", alignItems: "center", gap: 4, maxWidth: 450 }}>
            <Typography sx={{ textAlign: 'center' }}>Connecting to your {service} account</Typography>
            <CircularProgress color="inherit" size={80} />
            <Typography sx={{ textAlign: 'center' }}>Please wait</Typography>
          </Stack>
        </Card>
      </Backdrop>
    </AppTheme>
  );
}